module.exports = __webpack_public_path__ + "media/images/how_it_works/6-2ef8d911e3d8aa7d35908514e5a47e11.svg";